import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash-es';
import { TimingOptionEnum } from '@dev/ee-api/ee-api-models';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';

export const useGetSettingsInfo = (templateIndex = 0) => {
    const { isLoading, isNew, campaign } = useSelector(getCampainCreatorStore);

    const isDataLoaded = !isLoading && !isEmpty(campaign);
    const isEdit = isDataLoaded && !isNew;
    const template = campaign?.CampaignTemplates?.[templateIndex];

    const campaignName = isEdit ? campaign.Name : '';
    const poolName = (template?.Poolname !== 'default' && template?.Poolname) || 'Default';
    const sendStats = isEdit ? campaign.TrackingOptions?.SendStats : true;
    const timingOption = isEdit ? campaign.Options?.TimingOption : TimingOptionEnum.None;
    const trackOpens = isEdit ? campaign?.TrackingOptions?.TrackOpens : true;
    const trackClicks = isEdit ? campaign?.TrackingOptions?.TrackClicks : true;

    const utmSourceValue = template?.UTM?.UtmSource ?? '';
    const utmMediumValue = template?.UTM?.UtmMedium ?? '';
    const utmCampaignValue = template?.UTM?.UtmCampaign ?? '';
    const utmContentValue = template?.UTM?.UtmContent ?? '';

    return {
        isEdit,
        campaignName,
        poolName,
        sendStats,
        timingOption,
        trackOpens,
        trackClicks,
        utmSourceValue,
        utmMediumValue,
        utmCampaignValue,
        utmContentValue,
    };
};
